
var SearchResultOverview = function () {
    this.GalleryKey             = String;
    this.SearchKey              = String;
    this.ResultCount            = Number;
    this.SearchedOn             = Date;
    this.IsPublicMapViewEnabled = Boolean;
}

module.exports = SearchResultOverview;